import api from 'core/api';

// eslint-disable-next-line import/prefer-default-export
export const movements = (data) => api.get('/movements/autocomplete', { params: data });
